var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "navbar has-shadow is-fixed",
    class: {
      'is-dark': _vm.isDark
    }
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/"
    }
  }, [_c('strong', [_vm._v("The Score")])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-burger",
    on: {
      "click": _vm.toggleMobileNav
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu",
    class: {
      'is-active': _vm.mobileNavVisible
    }
  }, [(_vm.chapter) ? _c('div', {
    staticClass: "navbar-start"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": '/chapter/' + _vm.chapter.id
    }
  }, [_vm._v(_vm._s(_vm.currentTitle))])], 1) : _c('div', {
    staticClass: "navbar-start"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.currentTitle))])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-end"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "navbar-item",
    on: {
      "click": _vm.toggleModal
    }
  }, [_vm._m(1)])])])]), _vm._v(" "), _c('citation', {
    attrs: {
      "isActive": _vm.modalVisible
    },
    on: {
      "close-citation": _vm.toggleModal
    }
  })], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "navbar-item"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "ion ion-ios-search"
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "ion ion-ios-more"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3001ab22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBar.vue
// module id = k5lG
// module chunks = 0